import { useRef } from 'react';
import { ICategoryNews, INews } from '@/api/home/types';
import { isNewsHref } from '@/util/isNewsHref';
import { newsDefaultImage } from '@/util/newsDefaultImage';
import { textOnly } from '@/util/sanitized';
import { useVisibilityWindow } from '@/util/useVisibilityWindow';
import { NewsCard } from '@/components/common/NewsCard';

export const News = ({
  news,
}: {
  news: INews | ICategoryNews,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);
  const image = isVisible ? (news.image || newsDefaultImage()) : '';

  const title = textOnly(news.title || '');
  const excerpt = textOnly(news.description || '');
  const category = news.categories?.[0]?.title;

  // Editorial `/news` links are served by the CMS, not this Next app, so
  // render them as a plain <a> — a next/link would RSC-prefetch and
  // client-navigate to a 404 (see NewsCard `external`).
  const href = news.link || '';

  return (
    <div ref={ref} className="h-full">
      <NewsCard
        title={title}
        excerpt={excerpt}
        image={image}
        category={category}
        href={href}
        external={isNewsHref(href)}
        className="h-full"
      />
    </div>
  );
};
